<div class="container-fluid">
  <!-- Page Title and Description -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-users"></i> <!-- Replace with your desired icon -->
    Quản Lý Loại Thành Viên
  </h1>
  <p class="mb-4 text-muted">
    Mô-đun Quản Lý Loại Thành Viên cho phép bạn quản lý hiệu quả các loại thành viên khác nhau trong hệ thống. Bạn có thể xem, thêm, chỉnh sửa hoặc xóa các loại thành viên khi cần thiết. Điều này đảm bảo rằng hệ thống của bạn có thể phân loại và xử lý chính xác các vai trò hoặc phân loại thành viên khác nhau, duy trì cấu trúc thành viên được tổ chức và cập nhật.
  </p>

    <!-- DataTales Example -->
    <div class="card mb-4">
      <div class="card-body">
        <div class="table-responsive">
         <!--  <app-add-button></app-add-button> -->
         <button
         (click)="openAddDialog()"
         class="btn btn-outline-success btn-icon-split"
       >
         <span class="icon text-success">
           <i class="fas fa-plus"></i>
         </span>
         <span class="text">Tạo Mới</span>
       </button>
       <button
        href="#"
        role="button"
        class="btn btn-outline-warning btn-icon-split"
        (click)="getAll()"
      >
        <span class="icon text-warning">
          <i class="fas fa-redo"></i>
        </span>
        <span class="text">Tải Lại</span>
      </button>
      <div *ngIf="loading; else loaded">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <ng-template #loaded>
          <app-typemember-list
            (editEvent)="edit($event)"
            (deleteEvent)="delete($event)"
            [typeMembers]="typeMembers$">
          </app-typemember-list>
          <app-modal-type-member
            [typeMemberI18n]="typeMemberI18n"
            [id]="id"
          ></app-modal-type-member>
      </ng-template>    
        </div>
      </div>
    </div>

</div>
